import { render, staticRenderFns } from "./Livechat8x8.vue?vue&type=template&id=aead3dda&"
import script from "./Livechat8x8.vue?vue&type=script&lang=ts&"
export * from "./Livechat8x8.vue?vue&type=script&lang=ts&"
import style0 from "./Livechat8x8.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports